export {default} from './ReportCardSubheading';
